"use client";

import { ReactNode } from "react";
import clsx from "clsx";
import styles from "./page-shell.module.css";

interface PageShellProps {
  children: ReactNode;
  className?: string;
}

const PageShell = ({ children, className }: PageShellProps) => {
  return (
    <div className={clsx(`${styles.pageShell}`, className)}>{children}</div>
  );
};

export default PageShell;
